import { QualificationDetailSortEnum } from "../../../common/enums/QualificationDetailSortEnum";
import { setSortAchievedCertificates } from "../QualificationDetailSlice";
import { Dispatch } from "redux";

interface Props {
    dispatch: Dispatch;
    sortAchievedCertificates: {
        sortName: string;
        isSorted: boolean;
    };
}

export const handleAchievedCertificatesSort = (props: Props) => () => {
    const { dispatch, sortAchievedCertificates } = props;

    switch (sortAchievedCertificates.sortName) {
        case QualificationDetailSortEnum.EMPLOYEE_NAME:
            dispatch(
                setSortAchievedCertificates({
                    sortName: sortAchievedCertificates.isSorted
                        ? QualificationDetailSortEnum.EMPLOYEE_NAME_ASC
                        : QualificationDetailSortEnum.EMPLOYEE_NAME_DESC,
                    isSorted: !sortAchievedCertificates.isSorted,
                }),
            );
            break;
        case QualificationDetailSortEnum.EDUCATOR_NAME:
            dispatch(
                setSortAchievedCertificates({
                    sortName: sortAchievedCertificates.isSorted
                        ? QualificationDetailSortEnum.EDUCATOR_NAME_ASC
                        : QualificationDetailSortEnum.EDUCATOR_NAME_DESC,
                    isSorted: !sortAchievedCertificates.isSorted,
                }),
            );
            break;
        case QualificationDetailSortEnum.VALID_AT:
            dispatch(
                setSortAchievedCertificates({
                    sortName: sortAchievedCertificates.isSorted
                        ? QualificationDetailSortEnum.VALID_AT_ASC
                        : QualificationDetailSortEnum.VALID_AT_DESC,
                    isSorted: !sortAchievedCertificates.isSorted,
                }),
            );
            break;
        case QualificationDetailSortEnum.EXPIRES_AT:
            dispatch(
                setSortAchievedCertificates({
                    sortName: sortAchievedCertificates.isSorted
                        ? QualificationDetailSortEnum.EXPIRES_AT_ASC
                        : QualificationDetailSortEnum.EXPIRES_AT_DESC,
                    isSorted: !sortAchievedCertificates.isSorted,
                }),
            );
            break;
        default:
            break;
    }
};
